import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 1,
  class: "section content-container"
}
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "island" }
const _hoisted_7 = { class: "level" }
const _hoisted_8 = { class: "level-right" }
const _hoisted_9 = { class: "level-item" }
const _hoisted_10 = { class: "table is-fullwidth" }
const _hoisted_11 = {
  id: "drop-down-menu",
  class: "menu-icon action"
}
const _hoisted_12 = ["onClick"]

import { answersApi } from '../services/answers';
import { AnswerListItemViewModel } from '../models/answers/answerListItemViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import Toast from '@/shared/services/toast';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import { LOAD_ANSWERS } from '@/store/answers/actionTypes';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import AddAnswerModal from '@/features/bots/components/AddAnswerModal.vue';
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'Answers',
  setup(__props) {

const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const loadAnswers = (forceLoad: boolean = false) => store.dispatch(LOAD_ANSWERS, forceLoad);

const answers = ref<AnswerListItemViewModel[]>([]);
const loading = ref(true);
const showCreateModal = ref(false);
const showDeleteModal = ref(false);
const answerToDelete = ref<AnswerListItemViewModel>();

onMounted(async () => {
  await getAnswers();
  loading.value = false;
});

function addAnswer() {
  showCreateModal.value = true;
}

function editAnswer(answer: AnswerListItemViewModel, created = false) {
  router.push({ name: 'bots-answer-editor', params: { id: answer.id }, query: { created: created.toString() } });
}

function deleteAnswer(answer: AnswerListItemViewModel) {
  answerToDelete.value = answer;
  showDeleteModal.value = true;
}

async function deleteAnswerConfirm() {
  if (!answerToDelete.value) return;

  showDeleteModal.value = false;
  try {
    await answersApi.deleteAnswer(currentWorkspace.value.id, answerToDelete.value.id);
    answers.value = answers.value.filter((answer) => answer.id !== answerToDelete.value?.id);
    Toast.showSuccess('Deleted FAQ');
  } catch (ex) {
    Toast.showError('Failed to delete FAQ : ' + ex.message);
  }
}

function getDeleteAnswerConfirmationMessage() {
  return `Are you sure you want to delete the <b>${HtmlFormatter.escapeHtmlCharacters(answerToDelete.value?.title || '')}</b> FAQ? The action is irreversible. Please type the name of the FAQ to confirm:`;
}

async function getAnswers() {
  answers.value = await loadAnswers(true);
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_badge = _resolveComponent("n-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("nav", _hoisted_7, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "level-left" }, null, -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        _createVNode(_component_n_button, {
                          id: "add-answer-button",
                          button: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (addAnswer())),
                          variant: "primary"
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createElementVNode("span", null, "Add FAQ", -1)
                          ])),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_10, [
                    _cache[11] || (_cache[11] = _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Frequently Asked Question"),
                      _createElementVNode("th", { class: "status-column" }, "Status"),
                      _createElementVNode("th", null, " ")
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (answer) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "answer-row",
                        key: answer.id
                      }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'bots-answer-editor', params: { id: answer.id } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(answer.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", null, [
                          (answer.status === 'live')
                            ? (_openBlock(), _createBlock(_component_n_badge, {
                                key: 0,
                                variant: "success"
                              }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createTextVNode("Live")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (answer.status === 'paused')
                            ? (_openBlock(), _createBlock(_component_n_badge, {
                                key: 1,
                                variant: "secondary"
                              }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode("Paused")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (answer.status === 'draft')
                            ? (_openBlock(), _createBlock(_component_n_badge, {
                                key: 2,
                                variant: "default"
                              }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("Draft")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_11, [
                          _createVNode(DropDownMenu, {
                            "go-left": true,
                            dropDownIcon: "dots"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (deleteAnswer(answer)),
                                class: "dropdown-item"
                              }, [
                                _createVNode(DeleteIcon),
                                _cache[10] || (_cache[10] = _createTextVNode(" Delete "))
                              ], 8, _hoisted_12)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ]),
                  (showDeleteModal.value)
                    ? (_openBlock(), _createBlock(ConfirmationModal, {
                        key: 0,
                        id: "delete-modal",
                        confirmationTitle: "Delete FAQ",
                        confirmationMessage: getDeleteAnswerConfirmationMessage(),
                        typeConfirmationValidationMessage: answerToDelete.value.title,
                        confirmButtonLabel: "Delete",
                        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (deleteAnswerConfirm())),
                        onCancel: _cache[2] || (_cache[2] = ($event: any) => (showDeleteModal.value = false))
                      }, null, 8, ["confirmationMessage", "typeConfirmationValidationMessage"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showCreateModal.value)
      ? (_openBlock(), _createBlock(AddAnswerModal, {
          key: 2,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showCreateModal.value = false)),
          onAnswerAdded: _cache[4] || (_cache[4] = (answer) => editAnswer(answer, true))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})